// extracted by mini-css-extract-plugin
module.exports = {"direction":"MainPageGenres-styles_direction__1Gskt","directionName":"MainPageGenres-styles_directionName__dp_Q2","directionImg":"MainPageGenres-styles_directionImg__BwDQp"};